import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

interface RouterContext {
  auth: {
    user: { id: string; email: string | null; username: string | null } | null
    isLoading: boolean
  }
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return <Outlet />
}
